'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import HeaderVariety from '../shared/header-variety';
import SocialLinks from '../shared/SocialLinks';
import Image from '@repo/ui/src/components/Image/New';
import { classNames } from '@repo/ui/src/utils/classNames';

const BioHeaderCard = ({
  image,
  photoPosition,
  title,
  description,
  facebookLink,
  instagramLink,
  twitterLink,
  youtubeLink,
  websiteLink,
  overLappingPrevComponent,
  headerVariation,
}) => {
  return (
    <section data-testId="bio_header_card">
      <Image
        src={buildImageSrc(image, 960, 4, 1)}
        alt={image?.name}
        width={0}
        height={400}
        sizes="100vw"
        className="tw-flex md:tw-hidden tw-object-cover tw-h-[400px] tw-w-full"
      />
      <div
        className={classNames(
          'tw-max-w-[960px] lg:tw-max-w-[1140px] tw-mx-auto tw-px-2 sm:tw-px-4',
          overLappingPrevComponent && 'md:tw-relative md:tw-top-[-50px] md:tw-z-[100]',
        )}
      >
        <div className=" md:tw-mx-5 tw-bg-white tw-relative tw-top-[-50px] md:tw-top-0">
          <div
            className={classNames(
              'tw-flex tw-flex-col md:tw-items-stretch',
              photoPosition === 'photo-right' ? 'md:tw-flex-row-reverse' : 'md:tw-flex-row',
            )}
          >
            <div className="md:tw-flex-[4] lg:tw-flex-[3]">
              <Image
                src={buildImageSrc(image, 350, 4, 5)}
                alt={image?.name}
                className="tw-hidden md:tw-flex tw-max-w-full tw-h-full tw-object-cover tw-object-fit"
                height={440}
                width={350}
              />
            </div>

            <div
              className={classNames(
                'md:tw-flex-[8] lg:tw-flex-[9] tw-p-3 sm:tw-p-5 md:tw-p-4 lg:tw-p-10 tw-border-warm-200 tw-border tw-text-center tw-border-t md:tw-text-left md:tw-border-b',
              )}
            >
              <div className="tw-mt-1 tw-mb-3">
                <HeaderVariety
                  defaultVariation="h3"
                  headerVariation={headerVariation?.headerVariation}
                >
                  {title}
                </HeaderVariety>
              </div>
              <p className="tw-text-body2 tw-mb-4 md:tw-mb-5">{description}</p>
              <div className={classNames('tw-flex tw-justify-center md:tw-justify-start')}>
                <SocialLinks
                  facebook={facebookLink}
                  instagram={instagramLink}
                  twitter={twitterLink}
                  youtube={youtubeLink}
                  website={websiteLink}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BioHeaderCard;
